// extracted by mini-css-extract-plugin
export default {"information_table":"AddSpend_information_table__h9s-l","selectWrapper":"AddSpend_selectWrapper__qykVs","addWrapper":"AddSpend_addWrapper__W3GYC"};